class templateLoactorJS {
    constructor() {
        this.domEvent();
    }

    /**
     * 
     * 
     */
    domEvent(){

        if(document.querySelector('[data-disneySpringmap]') != null){
            document.querySelectorAll('[data-disneySpringmap]').forEach( element => {
              element.addEventListener('click' , (event) => {
                event.preventDefault();
                event.target.closest('[data-disneySpringmap]').classList.add('loading');
                var destinationLat = 28.37010 // Destination latitude
                var destinationLng = -81.51682; // Destination longitude
                this.redirectToDestination(destinationLat, destinationLng);
              })
            })
        }

        if(document.querySelector('[data-midtown]') != null){
          document.querySelectorAll('[data-midtown]').forEach( element => {
            element.addEventListener('click' , (event) => {
              event.preventDefault();
              event.target.closest('[data-midtown]').classList.add('loading');
              var destinationLat = 27.95310 // Destination latitude
              var destinationLng = -82.50326; // Destination longitude
                this.redirectToDestination(destinationLat, destinationLng);
            })
          })

          }

    }

    /**
     * 
     */
    redirectToDestination(destinationLat, destinationLng){
            if ("geolocation" in navigator) {
              navigator.geolocation.getCurrentPosition(function(position) {
                var currentLat = position.coords.latitude;
                var currentLng = position.coords.longitude;
                var url = `https://www.google.com/maps/dir/?api=1&origin=${currentLat},${currentLng}&destination=${destinationLat},${destinationLng}`;
                // window.location.href = url;
                window.open(url , '_blank');
                document.querySelectorAll('[data-midtown]').forEach(element => {
                  element.classList.remove('loading')
                })
                document.querySelectorAll('[data-disneySpringmap]').forEach( element => {
                  element.classList.remove('loading')
                })
              });
            } else {
              alert("Geolocation is not supported by this browser.");
            }
         
    }
}

typeof templateLoactorJS !== 'undefined' && new templateLoactorJS();

 

